import { useTranslation } from 'react-i18next';
import { ZuschlagsTabelle } from './ZuschlagsTabelle';
import { useEditSheetContext } from '../../EditSheetContext';
import { truncatNumberToTwoDigits } from '@/domain/arbeitszeiten/shared/util';
import { DurationDisplay } from '@/domain/arbeitszeiten/shared/util/durationDisplay';

export function Zuschlaege() {
  const { arbeitszeit } = useEditSheetContext();
  const { t } = useTranslation();

  const zuschlaege = arbeitszeit.zuschlaege ?? [];

  const gesamtDauer = zuschlaege.reduce((acc, curr) => acc + curr.dauer, 0);

  const gesamtBetrag = zuschlaege.reduce(
    (acc, curr) => acc + (curr.betrag ?? 0),
    0,
  );

  return (
    <div className="flex flex-col justify-center gap-6 shadow-card bg-white rounded-md p-2">
      <div className="bg-neutrals-200 min-h-10 rounded-lg py-2 px-4 text-sm flex justify-between items-center">
        <div className="w-[200px]">
          {t('domain.arbeitszeiten.sheet.zuschlaege.gesamt')}
        </div>
        <div className="flex gap-2 items-center">
          <DurationDisplay duration={gesamtDauer} />

          {zuschlaege.some((zuschlag) => zuschlag.betrag !== null) && (
            <>
              <div className="h-6 bg-neutrals-700 w-px" />
              <div className="flex gap-1 items-baseline">
                <span className="font-semibold">
                  {truncatNumberToTwoDigits(gesamtBetrag)}
                </span>
                <span className="text-neutrals-700 text-xs">
                  {t('general.currency.EUR')}
                </span>
              </div>
            </>
          )}
        </div>
      </div>
      <ZuschlagsTabelle zuschlaege={zuschlaege} />

      {zuschlaege.length === 0 && (
        <div className="flex justify-center text-sm text-neutrals-700 pb-4">
          {t('domain.arbeitszeiten.sheet.zuschlaege.empty')}
        </div>
      )}
    </div>
  );
}
